import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetEmspUsersInvoicesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/emsp-users-invoices/get-emsp-users-invoices-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchEmspBoInvoiceListContext } from '../../emsp-bo-invoice.context';
import { EmspBoInvoiceListFilterSearchFormStep1Controller } from '../emsp-bo-invoice-list-filter-search-form-step-1/emsp-bo-invoice-list-filter-search-form-step-1.controller';

export interface EmspBoInvoiceListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetEmspUsersInvoicesPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetEmspUsersInvoicesPaginatedModel>;
  onCancel: () => void;
}

export const EmspBoInvoiceListFilterSearchFormController = (
  props: EmspBoInvoiceListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchEmspBoInvoiceListContext();

  return (
    <HeadlessFormProvider<GetEmspUsersInvoicesPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <EmspBoInvoiceListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
